
(function () {
    'use strict';

    angular
        .module('controlModule')
        .directive('grcControlAssessment', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope = _.clone(boxTmplScope);
        directiveScope.readOnly = '@';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller', '$mdToast', 'commonAricService', '$state', function ($rootScope, $scope, $controller, $mdToast, commonAricService, $state) {
                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/control/grcControlAssessment.[Template].tpl.html';

                // Permissions default values
                $scope.boxFeatureRole = $scope.boxFeatureRole || 'ControlGrpBusinessUnit_GovernanceManagement';
                $scope.boxPermissionKey = $scope.boxPermissionKey || 'Assessment';

                $controller('BoxTmplController', { $scope: $scope });

                $scope.$watch('readOnly', function() {
                    if (typeof $scope.readOnly === 'string') {
                        $scope.readOnly = $scope.readOnly === 'true';
                    }
                    $scope.readOnly = $scope.readOnly || !$scope.boxPermissions.Edit;
                });

                // Show Control Status ?
                $scope.showControlStatus = function () {
                    if (!$scope.boxModel.ControlStatus) { return; }

                    return true;
                };

                $scope.view    = {};
                $scope.ctxtDir = {
                    showCollapsed: true
                };

                // Go To Assessment
                $scope.goToAssesment = function () {
                    $scope.clickOnBox();
                };

                // Update Control To Assess
                $scope.updateControlToAssess = function (updatedControlToAssess) {
                    $scope.boxModel = updatedControlToAssess.Assessment;

                    $scope.refreshBoxPermissions();
                    $scope.readOnly = $scope.readOnly || !$scope.boxPermissions.Edit;
                };

                // Show Cancel Assessment Action?
                $scope.showCancelAssessmentAction = function() {
                    if ($scope.readOnly) return false;
                    if ($scope.view.isEditingLevelOfTesting) return false;
                    if (!$scope.boxModel) return false;
                    if (!$scope.boxModel.GovernanceProcess) return false;
                    if (!$scope.boxModel.GovernanceProcess.IsActive) return false;

                    return $scope.boxModel.IsAssessed;
                };
                $scope.isShowCancelAssessmentAction = $scope.showCancelAssessmentAction();

                // Cancel Control Assessment
                $scope.cancelControlAssessment = function () {
                    return commonAricService
                        .cancelControlAssessment({
                            Assessment: $scope.boxModel,
                            Control: $scope.boxContext.Control
                        })
                        .then(function (savedControlToAssess) {

                            $mdToast.show(
                                 $mdToast
                                     .simple()
                                     .content('Pre-Assessment has been cancelled')
                                     .position('top right')
                                     .hideDelay($scope.govNotificationDelay)
                                     .action('OK')
                                     .theme('danger')
                            );

                            $scope.updateControlToAssess(savedControlToAssess);
                            $state.go($state.current, {}, { reload: true });
                        });
                };

                // Show Ready For Testing Review?
                $scope.showReadyForTestingReview = function () {
                    if (!$scope.boxModel.IsAssessed) return false;
                    if ($scope.boxModel.IsTestingReadyForReviewSubmitted) return false;
                    if ($scope.readOnly) return false;

                    return $scope.boxModel.HasEnoughForTestingToReview;
                };

                // Submit Ready For Testing Review
                $scope.submitReadyForTestingReview = function () {
                    return commonAricService
                            .submitControlTestingReadyForReview($scope.boxModel)
                            .then(function () {
                                return commonAricService
                                        .getControlToAssess($scope.boxModel.ControlID)
                                        .then($scope.updateControlToAssess)
                                        .then(function () {
                                            $scope.pageIsNotDirty();
                                        });
                            });
                };
            }],

            link: function (scope, elem, attrs) {

                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();